/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import { i18n } from 'element-react';
import locale from 'element-react/src/locale/lang/ko';

i18n.use(locale);

import 'styles/main.scss';
import 'element-theme-default';
import 'lib/localCart';

// import registerServiceWorker from './registerServiceWorker';

const render = window.__REDUX_STATE__ ? ReactDOM.hydrate : ReactDOM.render;
const isDev = process.env.NODE_ENV === 'development' || process.env.MODE_ENV === 'staging';

if (typeof window !== 'undefined') {
  render(<Root />, document.getElementById('root'));
}
// registerServiceWorker();

if (!isDev) {
  // GTM Load
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KJXF37L');

  // Clarity Load
  (function(c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'su1br4d3ti');
}



// WEBPACK FOOTER //
// ./src/index.js